import { FormattedMessage } from 'react-intl';

export type CategoryOption = 'CUSTOMER' | 'PARTNER' | 'MY_COMPANY' | 'MISC';
export const categoryOptionValues: CategoryOption[] = ['CUSTOMER', 'PARTNER', 'MY_COMPANY', 'MISC'];

export const resolveCategoryOptionLabel = (category: CategoryOption) => {
    switch (category) {
        case 'CUSTOMER':
            return <FormattedMessage id={'intl-msg:geofence-administration.geofenceOrPoiType.customer'} />;
        case 'PARTNER':
            return <FormattedMessage id={'intl-msg:geofence-administration.geofenceOrPoiType.partner'} />;
        case 'MY_COMPANY':
            return <FormattedMessage id={'intl-msg:geofence-administration.geofenceOrPoiType.myCompany'} />;
        case 'MISC':
            return <FormattedMessage id={'intl-msg:geofence-administration.geofenceOrPoiType.miscellaneous'} />;
        default:
            throw new Error(`Unknown category type: ${category}`);
    }
};
